import css from 'styled-jsx/css';
import Colors from './colors';
import Breakpoints from './breakpoints';
import FontSizes from './fontSizes';

const { body, border, bgTertiary, bodyLightest } = Colors;

const { minTablet, minDesktop, minDesktopLG } = Breakpoints;

const { xsBase, smBase, mdBase, lgBase } = FontSizes;

export default css.global`{
    /* -------------------------------------> INDEX */
    /* 0.  MEYERS RESET */
    /* 1.  CORE */
    /* 2.  FORM ELEMENTS */
    /* 3.  FONTS */
    /* 4.  ICONS */

    /* -------------------------------------> 0. MEYERS RESET */
    /* http://meyerweb.com/eric/tools/css/reset/
     v2.0 | 20110126
     License: none (public domain)
    */

    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        line-height: 1;
        font-family: 'Proxima Nova', sans-serif;
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    /* -------------------------------------> 1. CORE */
    html,
    body {
        font-family: Proxima Nova, Helvetica Neue, Arial, sans-serif;
        line-height: 1.3;
        color: ${body};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    html {
        font-size: ${xsBase};
    }

    @media ${minTablet} {
        html {
            font-size: ${smBase};
        }
    }

    @media ${minDesktop} {
        html {
            font-size: ${mdBase};
        }
    }

    html[dir=rtl] body {
        font-family: Cairo, sans-serif;
    }

    body {
        min-height: 100vh;
        background-color: ${bgTertiary};
    }

    strong, b {
        font-weight: bold;
    }

    a {
        text-decoration: none;
        cursor: pointer;
        color: inherit;
    }

    a, button {
        cursor: pointer;
    }

    /* remember to define focus styles! */
    a:focus,
    input:focus,
    button:focus {
        outline: 0;
    }

    /* -------------------------------------> 2. FORM ELEMENTS */
    input, button, textarea, select {
        font: inherit;
        color: inherit;
        padding: 0;
        margin: 0;
        border: 0;
        box-sizing: border-box;
    }

    input, textarea, select  {
        border: 1px solid ${bodyLightest};
    }

    input[type="search"] {
        -webkit-appearance: textfield;
    }

    input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none;
    }


    html[dir=rtl] .sc-htpNat {
      transform: rotateY(-180deg);
      margin: 0 10px;
    }


    button {
        background-color: transparent;
    }

    /** ----PAGINATION ***/

    .paginationCtr {
        display: flex !important;
        align-items: center;
        justify-content: center;

    }

    .paginationCtr li {
        width: 30px;
        height: 30px;
        align-items: center;
        text-align: center;
        display: flex;
        justify-content: center;
        margin: 10px;
        color: ${Colors.sub};
        box-sizing: border-box;
        font-size: 0.91rem;
        position: relative;

    }

    .paginationCtr li a {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
    .paginationCtr .disabled {
        display: none;
    }
    .paginationCtr li:hover,
    .paginationCtr .selectedPagination {
        border: 1px solid ${Colors.border};
        color: ${Colors.body};
    }

    /* -------------------------------------> 3. FONTS */
    @font-face {
      font-family: "Proxima Nova";
      src: url("/static/fonts/1274145/910c69c9-1457-45b2-9db2-09eb4b2921eb.eot?#iefix");
      src: url("/static/fonts/1274145/910c69c9-1457-45b2-9db2-09eb4b2921eb.eot?#iefix") format("eot"),
        url("/static/fonts/1274145/38b02c72-795a-436d-96b6-63bf366b0b4c.woff2") format("woff2"),
        url("/static/fonts/1274145/5e902f22-dc96-42db-9cea-596fd6e0128f.woff") format("woff"),
        url("/static/fonts/1274145/7a4accfd-087c-4552-a16f-a3eba295def8.ttf") format("truetype");
      font-weight: 300;
      font-style: normal;
    }
    @font-face {
      font-family: "Proxima Nova";
      src: url("/static/fonts/1274151/0020eb30-c98c-4a76-aaa5-c39374f14534.eot?#iefix");
      src: url("/static/fonts/1274151/0020eb30-c98c-4a76-aaa5-c39374f14534.eot?#iefix") format("eot"),
        url("/static/fonts/1274151/781c5453-0067-4e64-9386-7c0726d63d57.woff2") format("woff2"),
        url("/static/fonts/1274151/510df0e5-5b9f-4a1c-b46a-bcf1739bda43.woff") format("woff"),
        url("/static/fonts/1274151/47e08118-5050-469b-a40c-dc3b2307e87e.ttf") format("truetype");
      font-weight: normal;
      font-style: normal;
    }
    @font-face {
      font-family: "Proxima Nova";
      src: url("/static/fonts/1274157/2e16962e-d63b-4e8e-a35c-dc7ba5faf6f6.eot?#iefix");
      src: url("/static/fonts/1274157/2e16962e-d63b-4e8e-a35c-dc7ba5faf6f6.eot?#iefix") format("eot"),
        url("/static/fonts/1274157/672e09ff-117f-47a9-ad39-2af9420ccb79.woff2") format("woff2"),
        url("/static/fonts/1274157/db9d12b0-9307-4b1f-88bf-ebb676516c3b.woff") format("woff"),
        url("/static/fonts/1274157/79d731fe-d29c-48b7-9312-f503ee13216f.ttf") format("truetype");
      font-weight: 600;
      font-style: normal;
    }
    @font-face {
      font-family: "Proxima Nova";
      src: url("/static/fonts/1274163/c46a6af2-17e1-44cd-b22e-cde8ac5522bc.eot?#iefix");
      src: url("/static/fonts/1274163/c46a6af2-17e1-44cd-b22e-cde8ac5522bc.eot?#iefix") format("eot"),
        url("/static/fonts/1274163/36b2c5d9-5814-4505-ba7a-f94849f9d8d9.woff2") format("woff2"),
        url("/static/fonts/1274163/a77f80ae-abcf-401e-9cb3-ab84498fc03b.woff") format("woff"),
        url("/static/fonts/1274163/7f5a805f-22af-4c2d-b5f9-ab2f4738f783.ttf") format("truetype");
      font-weight: bold;
      font-style: normal;
    }

    /* -------------------------------------> 3. i) ARABIC FONTS */

    /* arabic */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 200;
      src: local('Cairo ExtraLight'), local('Cairo-ExtraLight'), url(https://fonts.gstatic.com/s/cairo/v2/5LOQ_MoEyLNG0tEIw7VXBhkAz4rYn47Zy2rvigWQf6w.woff2) format('woff2');
      unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+E0FF, U+EFFD, U+F000, U+FB50-FDFF, U+FE80-FEFC;
    }
    /* latin-ext */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 200;
      src: local('Cairo ExtraLight'), local('Cairo-ExtraLight'), url(https://fonts.gstatic.com/s/cairo/v2/XsUOtFIEOx9iWLLrJsllsBkAz4rYn47Zy2rvigWQf6w.woff2) format('woff2');
      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 200;
      src: local('Cairo ExtraLight'), local('Cairo-ExtraLight'), url(https://fonts.gstatic.com/s/cairo/v2/m_6Y_1Nb823vSGJGfT_5vHYhjbSpvc47ee6xR_80Hnw.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2212, U+2215;
    }
    /* arabic */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 400;
      src: local('Cairo'), local('Cairo-Regular'), url(https://fonts.gstatic.com/s/cairo/v2/KHiPzIiPko_Fw3pWntR2CoDGDUGfDkXyfkzVDelzfFk.woff2) format('woff2');
      unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+E0FF, U+EFFD, U+F000, U+FB50-FDFF, U+FE80-FEFC;
    }
    /* latin-ext */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 400;
      src: local('Cairo'), local('Cairo-Regular'), url(https://fonts.gstatic.com/s/cairo/v2/iExxv6nlTbTZ7OYq-WHjN4DGDUGfDkXyfkzVDelzfFk.woff2) format('woff2');
      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 400;
      src: local('Cairo'), local('Cairo-Regular'), url(https://fonts.gstatic.com/s/cairo/v2/9AWxzDXz2R7tHfJeCoIOqqCWcynf_cDxXwCLxiixG1c.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2212, U+2215;
    }
    /* arabic */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 700;
      src: local('Cairo Bold'), local('Cairo-Bold'), url(https://fonts.gstatic.com/s/cairo/v2/RLgQnjqLWN5-LcxkRZr1cBkAz4rYn47Zy2rvigWQf6w.woff2) format('woff2');
      unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+E0FF, U+EFFD, U+F000, U+FB50-FDFF, U+FE80-FEFC;
    }
    /* latin-ext */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 700;
      src: local('Cairo Bold'), local('Cairo-Bold'), url(https://fonts.gstatic.com/s/cairo/v2/UlKq8fG0ZzFfhYvIA2PuURkAz4rYn47Zy2rvigWQf6w.woff2) format('woff2');
      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: 'Cairo';
      font-style: normal;
      font-weight: 700;
      src: local('Cairo Bold'), local('Cairo-Bold'), url(https://fonts.gstatic.com/s/cairo/v2/IGeshMgNVhb2XU2TGWkITnYhjbSpvc47ee6xR_80Hnw.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2212, U+2215;
    }


    /* -------------------------------------> 4. ICONS */
    @font-face {
      font-family: 'iconoon';
      src:  url('/static/fonts/iconoon.eot?heo0ls');
      src:  url('/static/fonts/iconoon.eot?heo0ls#iefix') format('embedded-opentype'),
        url('/static/fonts/iconoon.ttf?heo0ls') format('truetype'),
        url('/static/fonts/iconoon.woff?heo0ls') format('woff'),
        url('/static/fonts/iconoon.svg?heo0ls#iconoon') format('svg');
      font-weight: normal;
      font-style: normal;
    }

    [class^="icon-"], [class*=" icon-"] {
      /* use !important to prevent issues with browser extensions that change fonts */
      font-family: 'iconoon' !important;
      speak: none;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;

      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .icon-dashboard:before {
      content: "\\e900";
    }
    .icon-orders:before {
      content: "\\e901";
    }
    .icon-products:before {
      content: "\\e902";
    }
    .icon-statements:before {
      content: "\\e903";
    }
    .icon-settings:before {
      content: "\\e904";
    }
    .icon-faq:before {
      content: "\\e905";
    }
    .icon-search:before {
      content: "\\e906";
    }
    .icon-back-arrow:before {
      content: "\\e907";
    }
    .icon-print:before {
      content: "\\e908";
    }
    .icon-list:before {
      content: "\\e909";
    }
    .icon-edit:before {
      content: "\\e90a";
    }
    .icon-stack:before {
      content: "\\e90b";
    }
    .icon-export:before {
      content: "\\e90c";
    }
    .icon-angle-down:before {
      content: "\\e90d";
    }
    .icon-angle-up:before {
      content: "\\e90e";
    }
    .icon-minus:before {
      content: "\\e930";
    }
    .icon-plus:before {
      content: "\\e936";
    }
    .icon-star-o:before {
      content: "\\e93d";
    }
    .icon-star:before {
      content: "\\e93e";
    }
    .icon-trash:before {
      content: "\\e942";
    }
    .icon-checkmark:before {
      content: "\\ea10";
    }
    .icon-fwd-arrow:before {
      content: "\\e90f";
    }
    .icon-angle-left:before {
      content: "\\e910";
    }
    .icon-angle-right:before {
      content: "\\e911";
    }
    .icon-caret-down:before {
      content: "\\e912";
    }
    .icon-caret-up:before {
      content: "\\e913";
    }
    .icon-tick:before {
      content: "\\e914";
    }
    .icon-close:before {
      content: "\\e915";
    }
    .icon-envelope:before {
      content: "\\e918";
    }
    .icon-globe:before {
      content: "\\e91e";
    }
    .icon-phone:before {
      content: "\\e935";
    }
    .icon-truck:before {
      content: "\\e94c";
    }
    .icon-download:before {
      content: "\\ea11";
    }
    .icon-reports:before {
      content: "\\e916";
    }
    .icon-positive:before {
      content: "\\e937";
    }
    .icon-warning:before {
      content: "\\e947";
    }
    .icon-list-view:before {
      content: "\\e954";
    }
    .icon-table:before {
      content: "\\e9ab";
    }
    .icon-send:before {
      content: "\\e978";
    }
    .icon-receive:before {
      content: "\\e979";
    }
    .icon-tooltip:before {
      content: "\\e941";
    }
    .icon-re-request:before {
      content: "\\ea91";
    }
    .icon-bell:before {
      content: "\\ea38";
    }
    .icon-user:before {
      content: "\\ea83";
    }
    .icon-loop:before {
      content: "\\ea98";
    }
    .icon-storage:before {
      content: "\\ea99";
    }
    .icon-coins:before {
      content: "\\e917";
    }
    .icon-notepad:before {
      content: "\\e92e";
    }
    .icon-sales:before {
      content: "\\e919";
    }
    .icon-caret-both:before {
      content: "\\e91a";
    }
    .icon-disputes:before {
      content: "\\e91b";
    }
    .icon-grid:before {
      content: "\\ea89";
    }
}`;



// WEBPACK FOOTER //
// ./src/styles/globalStyles.js